
import React from 'react';

interface HeadToHeadHeaderProps {
  showHomeAwayOnly: boolean;
  setShowHomeAwayOnly: (value: boolean) => void;
}

const HeadToHeadHeader: React.FC<HeadToHeadHeaderProps> = () => {
  return null;
};

export default HeadToHeadHeader;
